import { render, staticRenderFns } from "./LongVideo.vue?vue&type=template&id=2674220c&scoped=true&"
import script from "./LongVideo.vue?vue&type=script&lang=js&"
export * from "./LongVideo.vue?vue&type=script&lang=js&"
import style0 from "./LongVideo.vue?vue&type=style&index=0&id=2674220c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2674220c",
  null
  
)

export default component.exports